import { jsx as _jsx } from "react/jsx-runtime";
import { getProduct, useProductStore } from '../../store/product';
import { useVariantsStore } from '../../store/variants';
import { getTemplateData } from '../../utils';
import { useGlobalSettings } from '../global-settings';
import ProductInfo from './detail/product-info';
import Loader from '../loader';
export default function ProductDetailTemplate({ templateData }) {
    const productId = getTemplateData('data-product-id', templateData);
    const setProduct = useProductStore((state) => state.set);
    const setVariants = useVariantsStore((state) => state.set);
    const extraFields = ['tabs', 'accessories', 'recommended'];
    const displayExtras = () => {
        extraFields.forEach((field) => {
            const fieldElement = document.getElementById(`product-${field}`);
            if (fieldElement) {
                fieldElement.classList.remove('d-none');
            }
        });
    };
    const { isInited } = useGlobalSettings(async (config) => {
        const product = await getProduct(`${config.api.product.get}/${productId}`);
        setProduct(product);
        setVariants({ variants: product.variants, attributes: product.attributes });
        displayExtras();
    });
    if (!isInited)
        return _jsx(Loader, {});
    return (_jsx("div", { children: _jsx(ProductInfo, {}) }));
}
